export const BCID_WITH_ALT_ID_EXPERIMENT_TYPE = 'bcidWithAltId';

export default {
  BCID_WITH_ALT_ID_EXPERIMENT_TYPE
};
